import { ApplicationDetails } from "../Components/Home/ApplicationDetails.types";
import { Column } from "react-table";
import IconFileInfo from "../../icons/IconFileInfo";
import { Link } from "react-router-dom";
import { FLOAT } from "html2canvas/dist/types/css/property-descriptors/FLOAT";
import { string } from "yup/lib/locale";


export type InspectionHistoryProps = {
    appData: ApplicationDetails | null;
    apNumber? : string;
    returnPath?: string;
    title?: string;
}; 

export interface InspectionCommentsData {
    finalInspectionNumber: string;
    inspectionFieldName: string;
    comment: string;
}

export interface InspectionHistoryData {
    applicationNumber: string;
    finalInspectionNumber: string;
    finalInspectionId: number;    
    appprovalDate: Date;
    applicantName: string;
    agentName: string;
    apnumber: string;
    permitNumber: string;
    propertyNumber: string;
    lot: string;
    block: string;
    propertyStreetAddress: string;
    propertyCity: string;
    propertyState: string;
    propertyZipCode: string;
    subDivision: string;
    isApproved: string;
    additionalInspectionRequired?: Boolean;
    provider: string;
    providerFirstName: string;
    providerLastName: string;
    dateUpdated: string;
    inspectionApprovedDate: string;
    inspectionFileName: string;
    inspectionFilePath: string;
    additionalComments: string;
    engineerSealedCertificate: string;
    engineerSealedCertificatePath: string;    

    ////Abandonment data
    tankPumpedDate: Date;
    tankCrushedFilledDate: Date;
    tankCrushedFilledCompliance: string;
    tankPumpedCompliance: string;

    ////AdditionalInformation Data     
    drainfieldType: Number;
    ehdcontactName: string;
    alarmCompliance: string;
    buildingAreaCompliance: string;
    contractorCompliance: string;
    drainfieldTypeCompliance: string;
    finalSiteGradeCompliance: string;
    locationConformsCompliance: string;

    stormwaterRunoffCompliance: string;
    supportDocumentCompliance: string;
    unobstructedAreaCompliance: string;

    ////DrainfieldInstallation Data    
    area1: number;
    area2: number;
    numberOfDrainline1: number;
    numberOfDrainline2: number;
    elevation1: number;
    dosingPump: number;
    distributionBoxOrHeader: string;
    elevationBenchmark: string;
    drainlineSeparationBedOrTrench: string;
    aggregateDepthCompliance: string;
    aggregateExcessiveCompliance: string;
    aggregateSizeCompliance: string;
    areaCompliance: string;
    depthOfCoverCompliance: string;
    distributionCompliance: string;
    distribution?: boolean; // Configuration/Distribution field
    configuration?: boolean; // Configuration field
    elevation2?: boolean; // Elevation2 field
    dosingPumpCompliance: string;
    drainlineSeparationCompliance: string;
    drainlineSlopeCompliance: string;
    elevationCompliance: string;
    numberOfDrainlinesCompliance: string;
    systemLocationCompliance: string;
    // Drainfield 1 Product fields
    drainfield1DrainfieldType?: number;
    drainfield1ProductMake?: number;
    drainfield1ProductModel?: number;
    drainfield1NumberOfUnits?: number;
    drainfield1NumberOfUnitsCompliance?: string;

    ////DrainfieldInstallation2 Data (Drainfield 2)
    drainfield2Area?: number;
    drainfield2AreaCompliance?: string;
    drainfield2DistributionCompliance?: string;
    drainfield2DistributionBoxOrHeader?: string;
    drainfield2NumberOfDrainlines?: number;
    drainfield2NumberOfDrainlinesCompliance?: string;
    drainfield2DrainlineSeparationCompliance?: string;
    drainfield2DrainlineSeparationBedOrTrench?: string;
    drainfield2DrainlineSlopeCompliance?: string;
    drainfield2DepthOfCoverCompliance?: string;
    drainfield2ElevationCompliance?: string;
    drainfield2Elevation?: number;
    drainfield2ElevationBenchmark?: string;
    drainfield2SystemLocationCompliance?: string;
    drainfield2DosingPumpCompliance?: string;
    drainfield2DosingPump?: number;
    drainfield2AggregateSizeCompliance?: string;
    drainfield2AggregateExcessiveCompliance?: string;
    drainfield2AggregateDepthCompliance?: string;
    drainfield2DrainfieldType?: number;
    drainfield2ProductMake?: number;
    drainfield2ProductModel?: number;
    drainfield2NumberOfUnitsCompliance?: string;
    drainfield2NumberOfUnits?: number;

    ////FillExcavationMaterial Data    
    areaReplacedLength: number;
    areaReplacedWidth: number;
    areaReplacedCompliance: string;
    // Historical excavation depth compliance - preserved for historical data
    excavationDepthCompliance: string;
    // New direct depth field - used going forward
    excavationDepth: number;
    replacementMaterialCompliance: string;
    // Media Layer fields
    mediaLayer1ComplianceId?: number;
    mediaLayer1Comment?: string;
    mediaLayer2ComplianceId?: number;
    mediaLayer2Comment?: string;
    mediaLayer2Bottom?: number;
    mediaLayer2Benchmark?: number;

    ////FilledMoundSystem Data
    drainfieldCoverCompliance: string;
    inspectionStatus : string;
    shoulderCompliance: string;
    slopeCompliance: string;
    stablization : string;
    stablizationId?: number;
    stablizationCompliance: string;

    ////Setback Data
    surfaceWater: number;
    ditches: number;
    privateWells: number;
    publicWells: number;
    irrigationWells: number;
    portableWaterLines: number;
    sleevedSealed: boolean;
    buildingFoundation: number;
    propertyLines: number;
    otherSetback: number;
    buildingFoundationCompliance: string;
    ditchesCompliance: string;
    irrigationWellsCompliance: string;
    otherCompliance: string;
    portableWaterLinesCompliance: string;
    privateWellsCompliance: string;
    propertyLinesCompliance: string;
    publicWellsCompliance: string;
    surfaceWaterCompliance: string;

    ////TankInstallation Data
    tankSize1: number;
    tankSize2: number;
    tankSize1Units?: string;
    tankSize2Units?: string;
    tankMaterialId1: number;
    tankMaterialId2: number;
    tankMaterialOtherDescription?: string;
    tank2MaterialOtherDescription?: string;
    multiChambered: boolean;
    inSeries?: boolean;
    tank2InSeries?: boolean;
    risers?: boolean;
    tank2Risers?: boolean;
    outletFilterId: number;
    legendId1: number;
    legendId2: number;
    depthToLidCompliance: string;
    depthToLidInches?: number;
    tank2DepthToLidInches?: number;
    legendCompliance: string;
    levelCompliance: string;
    multiChamberedCompliance: string;
    outletDeviceCompliance: string;
    outletFilterComplience: string;
    tank2Compliance: string;
    tank2LegendCompliance: string;
    tank2MaterialCompliance: string;
    tankCompliance: string;
    tankMaterialCompliance: string;
    watertightCompliance: string;
    // ATU/PBTS fields
    atuPbtCompliance?: string;
    atuPbtId?: number;
    tank2AtuPbtCompliance?: string;
    tank2AtuPbtId?: number;
    tank2OutletDeviceCompliance?: string;
    tank2MultiChamberedCompliance?: string;
    tank2MultiChamberedYesNo?: string;
    tank2OutletFilterCompliance?: string;
    tank2OutletFilterId?: number;
    tank2WatertightCompliance?: string;
    tank2LevelCompliance?: string;
    tank2DepthToLidCompliance?: string;
    ////Setback Data - Additional fields
    publicWellsOver2000Gpd?: number;
    publicWellsUnder2000Gpd?: number;
    potableWaterLinesSleeved?: boolean;
    potableWaterLinesSchedule40Pvc?: boolean;
    otherDescription?: string;
    ////FilledMoundSystem Data - Additional fields
    ownerAgentResponsible?: boolean;
    ////Abandonment Data - Additional fields
    soilVerificationCompliance?: string;
    soilProfile1Depth?: number;
    soilProfile1DepthBenchmark?: number;
    soilProfile2Depth?: number;
    soilProfile2DepthBenchmark?: number;
    observedWaterTable?: number;
    observedWaterTableBenchmark?: number;
    estimatedWetSeasonWaterTableElevation?: number;
    estimatedWetSeasonWaterTableElevationBenchmark?: number;
    soilProfiles?: any[]; // JSON array of soil profiles
    ////AdditionalInformation Data - EHD Contact
    ehdcontactId?: number;
}

export const inspectionHistoryColumns: readonly Column<InspectionHistoryData>[] = [
    {
        Header: "Application Number",
        accessor: "applicationNumber"
    },
    {
        Header: "Final Inspection Number",
        accessor: "finalInspectionNumber"
    },
    {
        Header: "Approval Date",
        accessor: "appprovalDate",
        Cell: ({ value }: { value?: Date }) => (
            value ? <>{new Date(value).toLocaleDateString()}</> : null
        ),
    },
    {
        Header: "Address",
        id: "address",
        accessor: (row: InspectionHistoryData) => 
            `${row.propertyStreetAddress}, ${row.propertyCity}, ${row.propertyState} ${row.propertyZipCode}`
    },
    {
        Header: "Actions",
        id: "actions",
        accessor: (row: InspectionHistoryData) => (
            <>
                <div className="row">
                    <div className="col-sm-4">
                        <Link 
                            to={{
                                pathname: '/summaryView',
                                search: `?applicationId=${row.applicationNumber}&inspectionId=${row.finalInspectionId}`,
                                state: { finalInspectionData: row }
                            }}
                            className="cursor-pointer"
                        >
                            <IconFileInfo />
                        </Link>
                    </div>
                </div>
            </>
        ),
    }
];